import { Injectable, signal, Signal } from '@angular/core';

/**
 * Notifies when the right sidenav (My tasks / Chat drawer) opens or closes.
 * Used by permission badge directive to reposition overlays after layout shift.
 */
@Injectable()
export class RightSidenavStateService {
  private readonly openedState = signal<boolean>(false);

  readonly opened: Signal<boolean> = this.openedState;

  isOpened(): boolean {
    return this.openedState();
  }

  setOpened(opened: boolean): void {
    this.openedState.set(opened);
  }
}
